<template>
    <div>
        <div class="align-center d-flex" v-if="team.group">
            <img :src="'/api/public/image/get?size=200x200&type=team&id=' + team.id" style="width: 40px; height: 40px;" />
            <span class="font-weight-bold ml-2">{{ $translate('Our formation') }}</span>

            <v-spacer />

            <div v-if="showCaptain">
                <span class="font-weight-bold">{{ $translate('Team captain') }}</span>
                <v-icon v-if="captain" small color="success">mdi-check</v-icon>
                <v-icon v-else small color="error">mdi-star</v-icon>
            </div>
        </div>
        <div v-for="player in players" v-bind:key="player.id" class="d-flex my-1">
            <!-- Informative icon for player status -->
            <div class="mr-2">
                <template v-if="picture">
                    <v-avatar :size="20" class="mr-2">
                        <img :src="'/api/memberapi/image/member/get?size=50x50&id=' + player.id" class="user-image" />
                    </v-avatar>
                </template>
                <template v-else>
                    <v-icon color="error" v-if="player.declined">mdi-close-circle</v-icon>
                    <v-icon color="success" v-else-if="player.booked && !player.shirt_number">mdi-checkbox-marked-circle</v-icon>
                    <div class="number-circle" v-else-if="player.booked && player.shirt_number">{{ player.shirt_number }}</div>
                    <v-icon color="gray" v-else>mdi-help-circle</v-icon>
                </template>
            </div>
            <!-- Player name -->
            <div :class="{'not-booked': !player.booked}">{{ player.name }}</div>

            <v-spacer />

            <!-- Team captain -->
            <v-icon
                v-if="showCaptain"
                @click="setCaptain(player)"
                :color="player.captain ? 'primary' : ''"
                :class="{'text-shadow': player.captain}"
            >
                mdi-crown
            </v-icon>
        </div>
    </div>
</template>
<script>
export default {
    name: 'PlayerFormationWithCaptain',

    props: {
        players: {
            type: Array,
            required: true
        },
        team: {
            type: Object,
            required: true
        },
        match: {
            type: Object,
            required: true
        },
        showCaptain: {
            type: Boolean,
            required: true
        },
        picture: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isTeamLeader() {
            return this.team.group?.responsible?.includes(this.$store.state.user.id);
        },
        captain() {
            return this.players.find(player => player.captain);
        }
    },

    methods: {
        setCaptain(player) {
            // Only team leaders can set captains
            if (!this.isTeamLeader) {
                // Notify user that they are not allowed to set captains
                this.$store.commit('showSnackBar', {
                    text: this.$translate('Only team leaders can set the team captain'),
                    color: 'error'
                });
                return;
            }

            // Do nothing if player is already captain
            if (player.captain) { return; }

            // Set user as captain
            this.$api.post('/api/memberapi/teamsport/match/team/captain/set', {
                matchId: this.match.id,
                teamId: this.team.id,
                captainId: player.id == this.captain?.id ? null : player.id,
            });
        }
    }
}
</script>
